module.exports = __webpack_public_path__ + "img/big1-5.f7dd8d6e.jpg";